import { FileText } from "lucide-react";
import { useStore } from "@/hooks/useStore";

export const NoteFile = ({ id }: Dryp.Note) => {
	const {
		uiStore: { modalStore },
	} = useStore();

	return (
		<div
			className="w-10 h-10 rounded overflow-hidden border border-border bg-secondary flex items-center justify-center cursor-pointer hover:bg-secondary/80"
			onClick={() => modalStore.open("notePreview", { noteId: id })}
		>
			<FileText className="w-4 h-4 text-muted-foreground" />
		</div>
	);
};
